import { webStorage } from '@sidecar-utilities/browserUtils'

/**
 * Assuming that sh:member is the authenticated user, this function parses and
 * returns that user from storage.
 *
 * @returns {object} - The member object from storage
 */
export const getAuthedUser = () => {
  return JSON.parse(webStorage.getItem('sh:member') || '{}')
}
